import { RefObject } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useExportPdf, ExportPdfHeader } from '@/hooks/useExportPdf';

export interface ExportPdfButtonProps {
  contentRef: RefObject<HTMLElement>;
  fileName: string;
  header: ExportPdfHeader;
  disabled?: boolean;
  tooltipText?: string;
}

export function ExportPdfButton({
  contentRef,
  fileName,
  header,
  disabled = false,
  tooltipText,
}: ExportPdfButtonProps) {
  const { exportPdf, isExporting } = useExportPdf({ contentRef, fileName, header });

  const button = (
    <Button
      variant="outline"
      size="sm"
      onClick={exportPdf}
      disabled={disabled || isExporting}
      aria-label="Exportar relatório em PDF"
    >
      {isExporting ? (
        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
      ) : (
        <Download className="mr-2 h-4 w-4" />
      )}
      Exportar PDF
    </Button>
  );

  // Wrap with tooltip only when disabled and tooltipText is provided
  if (disabled && tooltipText) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            {/* Wrapper span so tooltip works on disabled button */}
            <span tabIndex={0}>{button}</span>
          </TooltipTrigger>
          <TooltipContent>{tooltipText}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return button;
}
